<template>
    <div class="NovedadesConsultar">
        <header class="bg-dark text-light text-center py-3">
            <h6>{{ novedad.titulo }}</h6>
            <p>{{ novedad.descripcion }}</p>
            <img src="../../../public/img/iconos/logo_color.png" class="img-fluid"/>
        </header>
        <main class="container features my-5">
            <section class="feature shadow-sm animate__animated animate__fadeIn" v-for="(item, index) of novedad.secciones" :key="index">
                <img :src="item.imagen.url" class="img-fluid" :class="{ 'right': !esImpar(index) }" />
                <div style="text-align: left;">
                    <span class="badge badge-primary mb-3">{{ item.categoria.toUpperCase() }}</span>
                    <h3>{{ item.titulo }}</h3>
                    <div v-html="item.descripcion" style="text-align: justify;"></div>
                </div>
            </section>
        </main>
        <hr />
    </div>
</template>

<script>
import { firebase, db } from "@/firebase";
export default {
    name: "NovedadesConsultar",

    data() {
        return {
            novedad: {
                id: this.$route.params.id,
                titulo: "",
                descripcion: "",
                secciones: [],
                registro: {
                    idUsuario: "",
                    estado: "",
                    creacion: "",
                    actualizacion: "",
                }
            },
        }
    },

    watch: {
        $route(to) {
            this.novedad.id = to.params.id;
        },
    },

    async created() {
        this.$isLoading(true);
        await this.obtenerNovedad();
        this.$isLoading(false);
    },

    methods: {
        async obtenerNovedad() {
            var docRef = db.collection("novedades").doc(this.novedad.id);
            docRef.get().then((doc) => {
                if (doc.exists) {
                    this.novedad = doc.data();
                    document.title = `Novedades / ${doc.data().titulo}  - IPER`
                } else {
                    console.log("No such document!");
                }
            });
        },

        esImpar(index) {
            return index % 2 !== 0;
        }
    }
}
</script>

<style scoped>
header p {
    font-size: 15pt !important;
}

header img {
    margin-bottom: -50px;
    width: 40px;
}

.features {
    margin-bottom: 80px !important;
}

.right {
    order: 2;
}

hr {
    display: none;
}

.feature {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
    grid-gap: 20px;
    justify-items: center;
    align-items: start;
    place-items: center;
    border-radius: 15px;
    padding: 25px;
    background: #f3f3f3;
    margin-bottom: 50px;
}

.feature {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
    grid-gap: 20px;
    justify-items: center;
    align-items: start;
    place-items: center;
    border-radius: 15px;
    padding: 25px;
    background: #f3f3f3;
    margin-bottom: 50px;
}

.feature img {
    border-radius: 15px;
}

@media screen and (max-width: 768px) {
    header p {
        font-size: 12pt !important;
    }

    header img {
        margin-bottom: -45px;
        width: 60px;
    }

    hr {
        display: block;
    }

    .feature {
        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
        padding: 20px;
        margin-bottom: 25px;
    }

    .features {
        margin-bottom: 50px !important;
    }
}
</style>